import http, { ExtendHttp } from '@common/ExtendHttp'
import { local, session } from 'me-view/lib/script/storage'
import ExtendRouter from './router/ExtendRouter'
import util from '@common/util'
import action from '@common/action'
import * as components from './components/index'
export { ExtendRouter, http, ExtendHttp, util, action }

// 添加退出登录事件监听
window.addEventListener('message', ({ data }) => {
  if (data.action === 'logout') {
    console.debug('程序监听到退出登录消息，开始清空缓存信息...')
    session.clear()
    local.clear()
    util.sendRedirect('/login')
  }

  if (data.action === 'heartbeat' && data.triggerOrigin !== location.origin) {
    action.heartbeat(/** 心跳当前系统 */)
  }

  if (data.action === 'heartbeat-trigger') {
    util.heartbeatBroadcast(data/** 心跳当前系统 */)
  }
})

export default {
  install (Vue) {
    for (const key in components) {
      const item = Reflect.get(components, key)
      Vue.component(item.name, item)
    }

    Vue.prototype.$http = http
    Vue.prototype.$ownButton = function (value) {
      return util.ownButton(value)
    }
    Vue.prototype.$ownMenu = function (value) {
      return util.ownMenu(value)
    }
    Vue.prototype.$dictValue = function (type, key, defaultValue) {
      const dictValue = (util.dictList(type) || []).find(({ value }) => value === String(key))
      return dictValue ? dictValue.label : (defaultValue || key)
    }

    Vue.prototype.$dictList = function (key) {
      return util.dictList(key)
    }
  }
}
